import I18n from 'I18n';
let languages = [];
export const getLanguages = () => {
  if (languages.length > 0) {
    return languages;
  }

  languages = [...Object.keys(I18n.baseLocales), ...Object.keys(I18n.publicLocales)];
  return languages;
};
export const CONSENT_FIELDS = ['communicationConsentCheckboxes', 'communicationConsentText', 'explicitProcessingConsentCheckboxLabel', 'explicitProcessingConsentText', 'implicitProcessingConsentText', 'legitimateInterestPrivacyPolicyText', 'privacyPolicyText'];